import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const monthlyCustomerReportParamsSchema = object({
  monthlyCustomerReportId: stringToNumber()
})
